// SYNCED FROM: VidaReactNative/src/features/AddressVerification/utils/trimAddress.ts
// Keep in sync. See SYNC.md.
import type { Address } from '../types';

/**
 * Trim leading and trailing whitespace from each field. We do this once before
 * submitting to Lob and before comparing against the verified result, so users
 * never see rogue whitespace and we don't compare values that differ only in
 * surrounding spaces.
 *
 * For `addressLine2`, an empty (or whitespace-only) value is normalized to
 * `undefined` so the post-trim address honors the type contract: line 2 is
 * either a non-empty string or absent.
 */
export const trimAddress = (address: Address): Address => {
  const line2 = address.addressLine2?.trim();
  return {
    addressLine1: address.addressLine1.trim(),
    addressLine2: line2 || undefined,
    city: address.city.trim(),
    state: address.state.trim(),
    zip: address.zip.trim(),
  };
};
